$(document).ready(function () {

  /*
  var $slider = $(".complete-the-look__products");
  var totalProducts = $slider.find(".ctl-product").length;

  if (totalProducts > 1) {
    $slider.slick({
      dots: true,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            arrows: false,
            dots: true
          }
        }
      ]
    });
  }*/

  // Actualiza imagen y precio según variante seleccionada
  function updateProductCard($card) {
    var $select = $card.find(".ctl-product__variant-select");
    var $selectedOption = $select.find("option:selected");

    var newPrice = $selectedOption.data("price");
    var newComparePrice = $selectedOption.data("compare-price");
    var newImage = $selectedOption.data("image");

    $card.find(".ctl-product__price").text(newPrice);

    var $comparePrice = $card.find(".ctl-product__compare-price");
    if (newComparePrice && newComparePrice !== "") {
      $comparePrice.text(newComparePrice).removeClass("is-hidden");
    } else {
      $comparePrice.text("").addClass("is-hidden");
    }

    if (newImage && newImage !== "") {
      $card.find(".ctl-product__main-image").attr("src", newImage);
    }
  }

  // Inicializa cada card con la variante seleccionada por defecto
  $(".complete-the-look__products .ctl-product").each(function () {
    updateProductCard($(this));
  });

  // Actualiza imagen y precio cuando cambia la variante
  $(document).on("change", ".ctl-product__variant-select", function () {
    var $card = $(this).closest(".ctl-product");
    updateProductCard($card);
  });

  // Add to cart
  $(document).on("click", "button.ctl-product__addToCart", function () {
    var $button = $(this);
    var $card = $button.closest(".ctl-product");
    var $select = $card.find(".ctl-product__variant-select");
    var variantId = $select.val();

    var productData = {
      items: [
        {
          id: variantId,
          quantity: 1
        }
      ]
    };

    $button.prop("disabled", true).text("Adding...");

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: productData,
      dataType: "json",
      success: function () {
        $button.text("Added!");
        setTimeout(function () {
          $button.prop("disabled", false).text("Add To Cart");
        }, 1000);
      },
      error: function () {
        console.log("Error al agregar el producto al carrito");
        $button.prop("disabled", false).text("Add To Cart");
      }
    });
  });

});